import React from 'react';
import { connect } from 'react-redux';
import InspectorCardList from '../components/schedule_inspector/inspector_card_list';
import actions from '../actions/index';
import inspectorSelector from '../selectors/inspector_selector';

const mapStateToProps = (state) => {
  return inspectorSelector(state)
};

const mapDispatchToProps = dispatch => {
  return {
    handleMeetingChange: (previous, currentValue, selectedMeetings) => {
      dispatch(actions.changeMeetingNames(
        selectedMeetings,
        currentValue,
        Object.assign({}, this.props.data, {scheduleId: this.state.schedules.selected[0]})
      ));
    },
    handleStudentFilterChange: (previous, current) => {
      dispatch(actions.changeStudentCohortFilter(
        current.data.id,
        current.selected
      ));
    }
  };
};

export const ScheduleInspectorContainer = React.createClass({

  render: function() {
    let element = null;
    if(!this.props.schedules.loading) {
      element = (
        <div className="abl-schedule-inspector-container">
          <div className="abl-inspector-content">
            <InspectorCardList
              id="select"
              render={this.props.showCards}
              items={this.props.cards}
              onMeetingChange={this.props.handleMeetingChange}
              onStudentFilterChange={this.props.handleStudentFilterChange}
              />
          </div>
        </div>
      );
    }
    
    return element;
  }

});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ScheduleInspectorContainer);



/** WEBPACK FOOTER **
 ** ./src/js/containers/schedule_inspector_container.js
 **/